$(document).ready(() => {
    $(".question h4").click((e) => {
        const $this = $(e.target);
        const $question = $this.closest('.question');

        if (!$question.hasClass("open")) {
            $(".question.open").removeClass("open");
        }

        $question.toggleClass("open");
    });
});
